/**
 * @param object - object to map
 * @param {Function} mapper - map simple items
 * @param {Function} pruningFunction - if pruning, we return mapper instead go inside object
 */
const deepMap = (object, mapper, pruningFunction = () => false) => {
    const getDeep = item => deepMap(item, mapper, pruningFunction);

    if (typeof object !== 'object' || object === null || pruningFunction(object)) {
        return mapper(object);
    }

    if (Array.isArray(object)) {
        return object.map(getDeep);
    }

    return Object.fromEntries(Object.entries(object).map(([key, value]) => [key, getDeep(value)]));
};

export default deepMap;
